import * as types from '../mutation-types'

const state = {
  isSignalrConnected: false,
  isSignalrDisconnected: true,
  isSignalrInvokeStatus: true
}

const getters = {
  getIsConnected: state => state.isSignalrConnected,
  getIsDisconnected: state => state.isSignalrDisconnected,
  getIsInvoke: state => state.isSignalrInvokeStatus
}

const actions = {
  connected ({ commit }) {
    commit(types.SET_SIGNALR_CONNECTED)
  },
  disconnected ({ commit }) {
    commit(types.SET_SIGNALR_DISCONNECTED)
  },
  invokeStatus ({ commit }, status) {
    commit(types.SET_SIGNALR_INVOKE_STATUS, status)
  }
}

const mutations = {
  [types.SET_SIGNALR_CONNECTED] (state) {
    state.isSignalrConnected = true
    state.isSignalrDisconnected = false
  },
  [types.SET_SIGNALR_DISCONNECTED] (state) {
    state.isSignalrDisconnected = true
    state.isSignalrConnected = false
  },
  [types.SET_SIGNALR_INVOKE_STATUS] (state, status) {
    state.isSignalrInvokeStatus = status
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/signalr.js